/* eslint-disable no-underscore-dangle */
import logo from '@/assets/image/logo.png';

export default function Product({ product, onClick }: { product: any; onClick: (product: any) => void }) {

  return (
    <div className="flex flex-col items-center">
      <button
        type="button"
        onClick={() => onClick(product)}
        className="w-[109.344px] h-[140px] max-[420px]:w-full max-[420px]:h-[140px] max-[420px]:max-w-[125px] max-[420px]:mx-auto flex flex-col items-center justify-center rounded-[8.24px] bg-white border-gray-300 border-[0.51px] backdrop-blur-[10.297px] shadow-[2.57px_2.57px_5.15px_0px_rgba(0,0,0,0.25)] hover:shadow-[2.57px_2.57px_8px_0px_rgba(0,0,0,0.3)] transition-all duration-200 cursor-pointer focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#039be5]/60 focus:ring-offset-white relative group"
      >
        <div className="flex flex-col items-center justify-center h-full w-full relative">
          <div className="w-full h-full flex items-center justify-center overflow-hidden">
            {product.thumbnail ? (
              <img 
                src={product.thumbnail} 
                alt={product.name} 
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full bg-gray-100 flex items-center justify-center">
                <img src={logo} className="w-6 h-6 object-contain" alt="logo" />
              </div>
            )}
          </div>
        </div>
        
        {/* Transparent overlay with edit icon */}
        <div className="absolute inset-0 bg-[#00000080] flex items-center justify-center rounded-[8.24px]">
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.54688 4.75L1.76172 11.5703V12.2383H2.42969L9.25 5.45312L8.54688 4.75ZM11.2539 0.25C11.4297 0.25 11.6406 0.320312 11.7812 0.460938L13.5391 2.21875C13.8203 2.5 13.8203 2.99219 13.5391 3.27344L12.168 4.64453L9.35547 1.83203L10.7266 0.460938C10.8672 0.320312 11.043 0.25 11.2539 0.25ZM8.54688 2.64062L11.3594 5.45312L3.0625 13.75H0.25V10.9375L8.54688 2.64062Z" fill="white"/>
          </svg>
        </div>
      </button>
      <div className="mt-3 text-[12px] text-[#333333] text-center w-full break-words leading-tight">
        {product.name || 'Untitled'}
      </div>
    </div>
  );
}